<template>
  <RevDialog name="BOUYGUES_IN_STORE_CANCEL" :title="i18n(translations.title)">
    <template #body>
      <div class="body-1 flex flex-col gap-16">
        <p>{{ i18n(translations.paragraph1) }}</p>
        <p class="whitespace-pre-line">
          {{ i18n(translations.paragraph2) }}
        </p>
      </div>
    </template>
    <template #footer="{ close }">
      <div class="flex flex-col gap-12">
        <CancelOrderButton :cart-selection-id>
          {{ i18n(translations.confirm) }}
        </CancelOrderButton>

        <RevButton variant="secondary" @click="close">
          {{ i18n(translations.close) }}
        </RevButton>
      </div>
    </template>
    <template #trigger="{ open }">
      <div class="text-center">
        <RevLink class="text-action-default-low" @click="open">
          {{ i18n(translations.link) }}
        </RevLink>
      </div>
    </template>
  </RevDialog>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevDialog } from '@ds/components/Dialog'
import { RevLink } from '@ds/components/Link'

import CancelOrderButton from '../CancelOrderButton/CancelOrderButton.vue'

import translations from './CancelOrder.translations'

defineProps<{
  cartSelectionId: string
}>()

const i18n = useI18n()
</script>
